// src/services/apiService.js
//const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:3001';
import { BASE_URL } from "./constant";
const API_BASE = process.env.REACT_APP_API_BASE || BASE_URL;

export async function fetchContent(contentId) {
  const res = await fetch(`${API_BASE}/api/categories/${contentId}`);
  //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");

if (!res.ok) throw new Error('Impossible de charger le contenu');
const json = await res.json();
// return the content object (assume json contains the record or data[0] per your API)
return json.data ? json.data : json;
}
export async function fetchContentAll() {
    const res = await fetch(`${API_BASE}/api/categories`);
    //const res = await fetch("http://localhost:3001/api/hls/1/master.m3u8");
  
  if (!res.ok) throw new Error('Impossible de charger le contenu');
  const json = await res.json();
  // return the content object (assume json contains the record or data[0] per your API)
  return json.data ? json.data : json;
}


// Save watch progress (backend should accept { id, position })
export async function saveProgress({ title }) {
  try {
    await fetch(`${API_BASE}/api/categories`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title }),
    });
  } catch (err) {
    console.warn('Save progress failed', err);
  }
}

// Save the video
export async function updateCategorie({ id, title  }) {
  try {
    await fetch(`${API_BASE}/api/categories`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, title }),
    });
  } catch (err) {
    console.warn('Save reactions failed', err);
  }
}


